import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  initState,
  sendRequest,
  selectQueryParams,
  changeDefaultQueryParams,
  changeStaticQueryParams
} from 'mt-react-common/common/reducers/list/reducer';

import TasksListAsOwner from '../../../../../../components/Tasks/TasksListAsOwner/index';

class TasksListAsOwnerContent extends Component {
  constructor(props) {
    super(props);
    this.props.changeDefaultQueryParams({
      ...{
        page: 1,
        sort: '-created_at'
      }
    });
    this.props.changeStaticQueryParams(this.props.staticQueryParams);
    this.props.sendRequest();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return <TasksListAsOwner reducerName={this.props.listReduceName} />;
  }
}

TasksListAsOwnerContent.defaultProps = {
  staticQueryParams: {}
};

TasksListAsOwnerContent.propTypes = {
  // IN
  listReduceName: PropTypes.string.isRequired,
  staticQueryParams: PropTypes.shape({}),
  // CONNECT
  changeDefaultQueryParams: PropTypes.func.isRequired,
  changeStaticQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired
};

// eslint-disable-next-line no-unused-vars
const mapStateToProps = (state, props) => ({
  selectQueryParams: selectQueryParams(state, props.listReduceName)
});

const mapDispatchToProps = (dispatch, props) => ({
  initState: () => dispatch(initState(props.listReduceName)),
  changeDefaultQueryParams: queryParams =>
    dispatch(changeDefaultQueryParams(props.listReduceName, queryParams)),
  changeStaticQueryParams: queryParams =>
    dispatch(changeStaticQueryParams(props.listReduceName, queryParams)),
  sendRequest: () => dispatch(sendRequest(props.listReduceName))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TasksListAsOwnerContent);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/MyTasks/_myTasksCommon/TasksListAsOwnerContent/TasksListAsOwnerContent.js